import z from 'zod';
import { LooseAutocomplete } from '../helpers/type-helpers';

export const CallTypeCodeEnum = z.string();
export type CallTypeCode = LooseAutocomplete<'AUDIO' | 'VIDEO'>;
